import * as React from "react";

import ContractForm from "../../../components/Forms/ParkingContract/ContractForm/FlowForm";

export default function ParkingContractCreate() {
  return <ContractForm />;
}
